import React from 'react';
import MuiMenuItem, { MenuItemProps as MuiMenuItemProps } from '@mui/material/MenuItem';

/**
 * Design System MenuItem
 * Adds support for color variants.
 */
export interface MenuItemProps extends MuiMenuItemProps {
  colorVariant?: string;
  backgroundVariant?: string;
}

const DSMenuItem = React.forwardRef<HTMLLIElement, MenuItemProps>(
  function DSMenuItem(
    { colorVariant = 'default', backgroundVariant = 'default', className = '', ...props },
    ref
  ) {
    let variantClass = '';
    if (colorVariant === 'white' && backgroundVariant === 'transparent') {
      variantClass = 'ds-menuitem-white-transparent';
    }
    // Add more variants as needed
    return (
      <MuiMenuItem ref={ref} className={`${variantClass} ${className}`} {...props} />
    );
  }
);

export default DSMenuItem;
